export const STORAGE_KEY = 'system-notifications-viewed';
